import o from "../packages/web-components/src/utils/data/phone-country-codes.json.js";
function d() {
  return o.map(function (e) {
    return {
      value: e.dial_code,
      label: e.dial_code + " " + e.name
    };
  });
}
export { d as formattedPhoneCountryCodes };